import { render } from "./NotificationsTelegram.vue?vue&type=template&id=046c1644&scoped=true"
import script from "./NotificationsTelegram.vue?vue&type=script&lang=js"
export * from "./NotificationsTelegram.vue?vue&type=script&lang=js"

import "./NotificationsTelegram.vue?vue&type=style&index=0&id=046c1644&scoped=true&lang=css"
import "./NotificationsTelegram.vue?vue&type=style&index=1&id=046c1644&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046c1644"]])

export default __exports__